import * as React from 'react'

export interface StackProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Layout direction. Defaults to `row`. */
  direction?: 'row' | 'column';
  /** Gap between children, in pixels. Defaults to `8`. */
  gap?: number;
  /** Cross-axis alignment (maps to `align-items`). */
  align?: React.CSSProperties['alignItems'];
}

/**
 * A minimal flexbox layout primitive. Handy for composing styleguide elements
 * (e.g. a row of buttons and badges) without every pilet re-inventing flex CSS.
 */
export function Stack ({ direction = 'row', gap = 8, align, style, children, ...rest }: StackProps) {
  const layout: React.CSSProperties = {
    display: 'flex',
    flexDirection: direction,
    gap,
    alignItems: align,
    ...style,
  }
  return (
    <div style={layout} {...rest}>
      {children}
    </div>
  )
}
